import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {v4 as uuidv4} from 'uuid';
import {NgForm} from '@angular/forms';
import {Message} from 'primeng/api';
import {ContactUsRequestDto, EmailControllerService} from '../../@api';
import {ProgressIndicatorService} from '../../@shared';
import {environment} from '../../../environments/environment';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'common-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class CommonContactComponent implements OnInit {
    @ViewChild('contactUsForm') contactUsForm: NgForm;

    msgs: Message[] = [];

    contact: ContactUsRequestDto = {
        profile: environment.access_profile,
        fullName: '',
        emailAddress: '',
        mobileNumber: '',
        company: '',
        message: ''
    }

    formSubmitted: boolean = false;
    uuid: string;

    constructor(@Inject(DOCUMENT) public document: Document,
                private emailControllerService: EmailControllerService,
                private progressIndicatorService: ProgressIndicatorService) {
    }

    ngOnInit(): void {
    }

    ngModelChanged($event: any): void {
        this.uuid = uuidv4();
    }

    send(): void {
        this.msgs = [];
        this.formSubmitted = true;
        this.uuid = uuidv4();
        if (this.contactUsForm.form.invalid || this.contactUsForm.form.invalid) {
            this.msgs.push({severity: 'error', detail: 'Please correct the errors and submit again.'});
        } else {
            this.progressIndicatorService.publish(true);
            this.emailControllerService.contactUsRequest(this.contact).subscribe(response => {
                this.progressIndicatorService.publish(false);
                if (response.status === '200 OK') {
                    this.msgs.push({severity: 'success', detail: 'Thank you for contacting us, your message was received.'});
                    this.formSubmitted = false;
                    this.contactUsForm.resetForm(true);
                    this.contact = {
                        profile: environment.access_profile,
                        fullName: '',
                        emailAddress: '',
                        mobileNumber: '',
                        company: '',
                        message: ''
                    }
                    setTimeout(() => {
                        this.msgs = [];
                        this.formSubmitted = false;
                    }, 5000);
                } else {
                    this.msgs.push({severity: 'error', detail: 'Your message failed to send. Please try again later.'});
                }
            }, error => {
                console.log(error);
                this.progressIndicatorService.publish(false);
                this.msgs.push({severity: 'error', detail: 'Your message failed to send. Please try again later. Error: ' + JSON.stringify(error)});
            });
        }
    }

    cancel(): void {
    }
}
